import { Star } from "lucide-react";
import { useState } from "react";

const StarRating = ({
  rating,
  setRating,
}: {
  rating: number;
  setRating: (v: number) => void;
}) => {
  const [hover, setHover] = useState(0);

  const handleStarClick = (starIndex: number) => {
    setRating(starIndex);
  };

  const handleStarHover = (starIndex: number) => {
    setHover(starIndex);
  };

  const displayRating = hover || rating;

  return (
    <div className="flex items-center gap-2">
      {[1, 2, 3, 4, 5].map((i) => {
        const isFull = displayRating >= i;

        return (
          <button
            key={i}
            type="button"
            onMouseEnter={() => handleStarHover(i)}
            onMouseLeave={() => setHover(0)}
            onClick={() => handleStarClick(i)}
            className="relative w-8 h-8 cursor-pointer group transition-transform hover:scale-110"
          >
            {/* Empty star */}
            <Star className="absolute inset-0 text-primary-200" strokeWidth={1.5} />

            {/* Full star */}
            {isFull && (
              <Star className="absolute inset-0 text-primary-600 fill-primary-600" />
            )}
          </button>
        );
      })}

      {rating > 0 && (
        <span className="ml-2 font-medium text-primary-800">
          {rating} / 5
        </span>
      )}
    </div>
  );
};

export default StarRating;
